<template>
  <div>
    <b-card class="mb-0" no-body>
      <validation-observer ref="modalEdit">
        <div class="p-1">
          <b-row>
            <b-col cols="12" md="4">
              <validation-provider #default="{ errors }" :rules="''" name="Loại file">
                <b-form-group label="Loại báo cáo">
                  <Select2 v-model="reportType" :options="typeReportList" :state="errors.length > 0 ? false:null"/>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" md="4">
              <validation-provider #default="{ errors }" :rules="''" name="Kho">
                <b-form-group label="Kho">
                  <select2-multiple-control v-model="serverParams.columnFilters.Store"
                                            :options="storeList.map(item => ({ id: item.Id, text: item.Name }))"/>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" md="4">
              <validation-provider #default="{ errors }" :rules="''" name="Trạng thái">
                <b-form-group label="Trạng thái">
                  <Select2 v-model="serverParams.columnFilters.Status" :options="statusList"
                           :state="errors.length > 0 ? false:null"/>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" md="4">
              <validation-provider #default="{ errors }" :rules="''" name="Từ ngày">
                <b-form-group label="Từ ngày">
                  <b-input-group label="Từ ngày">
                    <b-form-datepicker
                        v-model="serverParams.columnFilters.FromDate"
                        :date-format-options="{  year: 'numeric', month: 'numeric', day: 'numeric',}"
                        :state="errors.length > 0 ? false:null" close-button locale="vi-VN"
                        reset-button
                        today-button
                    />
                  </b-input-group>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" md="4">
              <validation-provider #default="{ errors }" :rules="''" name="Đến ngày">
                <b-form-group label="Đến ngày">
                  <b-input-group label="Đến ngày">
                    <b-form-datepicker
                        v-model="serverParams.columnFilters.ToDate"
                        :date-format-options="{  year: 'numeric', month: 'numeric', day: 'numeric',}"
                        :state="errors.length > 0 ? false:null" close-button locale="vi-VN"
                        reset-button
                        today-button
                    />
                  </b-input-group>
                </b-form-group>
              </validation-provider>
            </b-col>

          </b-row>
        </div>

      </validation-observer>
    </b-card>
    <div class="p-1 text-center">
      <b-button variant="primary" @click="$router.go($router.currentRoute)"> Xoá trắng</b-button>
      <b-button class="ml-1" variant="primary" @click="printDetail">Xem báo cáo</b-button>
      <b-button class="ml-1" variant="secondary" @click="exportExcel">Xuất file Excel</b-button>
    </div>
    <b-row>
      <b-col cols="12" md="12">
        <vue-pdf-app v-if="isHaveData==0" :fileName="currentItem.fileName" :pdf="pdf" class="rounded"
                     pageScale="100" style="height:calc(100vh - 400px)"></vue-pdf-app>
        <vue-pdf-app v-else-if="isHaveData==1" :fileName="currentItem.fileName" :pdf="pdf" class="rounded"
                     pageScale="100" style="height:calc(100vh - 400px)"></vue-pdf-app>
        <div v-else class="rounded" pageScale="100" style="height:85vh"> Không có dữ liệu</div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from 'vee-validate'
import {required} from '@validations'
import vSelect from 'vue-select'
import {VueGoodTable} from 'vue-good-table'
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BInputGroup,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTable,
  BTooltip,
  VBTooltip
} from 'bootstrap-vue'
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from 'vue-ripple-directive'
import '@core/scss/vue/libs/vue-good-table.scss';
import Select2 from 'v-select2-component';
import moment from 'moment';
import VuePdfApp from "vue-pdf-app";
import "vue-pdf-app/dist/icons/main.css";
import Select2MultipleControl from 'v-select2-multiple-component';
import {getUserData} from "@/auth/utils"

extend('laisuat', value => {
  if ((value + "").indexOf('.') < 0) {
    return true;
  }
  return (value + "").split('.')[1].length <= 2
});

export default {
  components: {
    VuePdfApp,
    BInputGroup,
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    Select2MultipleControl
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  mounted() {
    if (!this.userData || this.userData.user_level != 1) {
      this.reportType = "Usim_Xuat_Ban"
    }
    this.loadStores();
    useJwt.post('getMasterData/B2C_Campaign_List', this.serverParams).then(response => {
      this.campaigns = response.data.result;
      this.campaigns.splice(0, 0, {id: '0', text: 'Tất cả chiến dịch'})
    }).catch((error) => {
    });
  },

  watch: {
    $route(to, from) {
      this.pdf = null;
    },
  },
  data() {
    return {
      isLoading: false,
      editMode: false,
      currentItem: {attribute: {}},
      isHaveData: 0,
      pdf: null,
      campaigns: [],
      serverParams: {
        columnFilters: {
          Status: null
        },
        sort: [],
        page: 1,
        pageSize: 50
      },
      required,
      storeList: [],
      statusList: [
        {id: '2', text: 'Xuất bán'},
        {id: '1,3', text: 'Tồn kho'}
      ],
      typeReportList: [
        {id: 'Usim_Tong_Hop', text: 'Báo cáo usim tổng hợp'},
        {id: 'Usim_Xuat_Ban', text: 'Báo cáo usim xuất bán'}
      ],
      reportType: 'Usim_Tong_Hop'
    }
  },
  computed: {
    userData() {
      return getUserData() || null
    },
  },
  methods: {
    printDetail(row) {
      // if(!this.serverParams.columnFilters.Store) {
      //   this.$toast({ component: ToastificationContent, props: { title: 'Vui lòng chọn kho!', icon: 'AlertTriangleIcon', variant: 'warning' } });
      //   return;
      // }
      this.loading(true)
      useJwt.post('jasper', {
            name: 'B2C_SUMMARY_' + moment().format('YYYY-MM-DD') + ".pdf",
            type: 'pdf',
            src: 'web',
            report: this.reportType,
            parameter: {
              FromDate: this.serverParams.columnFilters.FromDate ? this.serverParams.columnFilters.FromDate : null,
              ToDate: this.serverParams.columnFilters.ToDate ? this.serverParams.columnFilters.ToDate : null,
              Status: this.serverParams.columnFilters.Status,
              Store: this.serverParams.columnFilters.Store && this.serverParams.columnFilters.Store.length != 0 ? this.serverParams.columnFilters.Store.reduce((prev, cur) => {
                if (prev != "") {
                  return prev + `,${cur}`
                } else {
                  return prev + `${cur}`
                }
              }, "") : null
            }
          }
          , {responseType: 'arraybuffer'}).then(response => {
        this.pdf = response.data;
        this.loading(false);
      }).catch((error) => {
        this.loading(false);
      });
    },
    exportExcel(row) {
      if (!this.serverParams.columnFilters.Store) {
        this.$toast({
          component: ToastificationContent,
          props: {title: 'Vui lòng chọn kho!', icon: 'AlertTriangleIcon', variant: 'warning'}
        });
        return;
      }
      this.loading(true)
      useJwt.post('jasper',
          {
            name: 'B2C_SUMMARY_' + moment().format('YYYY-MM-DD') + ".xlsx",
            type: 'xlsx',
            src: 'web',
            report: this.reportType,
            parameter: {
              FromDate: this.serverParams.columnFilters.FromDate ? this.serverParams.columnFilters.FromDate : null,
              ToDate: this.serverParams.columnFilters.ToDate ? this.serverParams.columnFilters.ToDate : null,
              Store: this.serverParams.columnFilters.Store && this.serverParams.columnFilters.Store.length != 0 ? this.serverParams.columnFilters.Store.reduce((prev, cur) => {
                if (prev != "") {
                  return prev + `,${cur}`
                } else {
                  return prev + `${cur}`
                }
              }, "") : null
            }
          }, {responseType: 'arraybuffer'}).then(response => {
        const a = document.createElement('a')
        a.href = URL.createObjectURL(new Blob(
            [response.data],
            {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
        ))
        a.download = 'B2C_SUMMARY_' + moment().format('YYYY-MM-DD') + ".xlsx"
        a.click()
        this.loading(false);
      }).catch((error) => {
        this.loading(false);
      });
    },
    loadStores() {
      useJwt.get('usim/store').then(response => {
        if (+response.data.code == 200) {
          this.storeList = response.data.result;
        } else {
          this.storeList = []
        }
      }).catch(error => {
        this.storeList = []
      })
    }
  },

}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
